import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage, getkey } from "../../services/helper/cl_Helper";

const initialState = {
    gamblingData: false,
    gamblingDataError: "",
    gamblingDataSuccess: "",
}

export const responibleGamblingSlice = createSlice({
    name: "responibleGambling",
    initialState,
    reducers: {
        setGamblingData: (state, action) => {
            state.gamblingData = action.payload;
        },
        setGamblingDataError: (state, action) => {
            state.gamblingDataError = action.payload;
        },
        setGamblingDataSuccess: (state, action) => {
            state.gamblingDataSuccess = action.payload;
        },
    }
});

export const { setGamblingData, setGamblingDataError, setGamblingDataSuccess } = responibleGamblingSlice.actions;

export default responibleGamblingSlice.reducer;

export const handleResponsibleGambling = (gamblingLimit, timeLimit, amt) => (dispatch) => {
    const token = getFromLocalStorage("gk");
    const getKeyLimit = getkey(gamblingLimit, timeLimit)
    let url = endpoints?.resGambling;
    let payload = {
        accessToken: token,
        [getKeyLimit]: amt
    }
    postRequest(url, payload)
        .then((res) => {
            if (res.data.code === "1000") {
                dispatch(setGamblingData(true));
                if (getKeyLimit === "dailyDepositLimit" || getKeyLimit === "dailyStakeLimit") {
                    dispatch(setGamblingDataSuccess("You have successfully set your Daily Limit"))
                } else if (getKeyLimit === "monthlyDepositLimit" || getKeyLimit === "monthlyStakeLimit") {
                    dispatch(setGamblingDataSuccess("You have successfully set your Monthly Limit"))
                } else if (getKeyLimit === "weeklyDepositLimit" || getKeyLimit === "weeklyStakeLimit") {
                    dispatch(setGamblingDataSuccess("You have successfully set your Weekly  Limit"))
                } else if (getKeyLimit === "timeLimit") {
                    dispatch(setGamblingDataSuccess("You have successfully set your Time Limit"))
                } else if (getKeyLimit === "selfExclusion" && timeLimit === "WEEK") {
                    dispatch(setGamblingDataSuccess("You have self-excluded yourself for a Week"))
                } else if (getKeyLimit === "selfExclusion" && timeLimit === "MONTH") {
                    dispatch(setGamblingDataSuccess("You have self-excluded yourself for a Month"))
                } else if (getKeyLimit === "selfExclusion" && timeLimit === "YEAR") {
                    dispatch(setGamblingDataSuccess("You have self-excluded yourself for a Year"))
                }
            } else {
                dispatch(setGamblingData(false));
                if (res?.data?.result?.message === "MONTHLY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED") {
                    dispatch(setGamblingDataError("You have recently set the Monthly Limit. Try after 12AM"));
                } else if (res?.data?.result?.message === "WEEKLY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED") {
                    dispatch(setGamblingDataError("You have recently set the Weekly Limit. Try after 12AM"));
                } else if (res?.data?.result?.message === "DAILY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED") {
                    dispatch(setGamblingDataError("You have recently set the Daily Limit. Try after 12AM"));
                } else if (res?.data?.result?.message === "SELF_EXCLUSION_UPDATES_PER_DAY_EXCEEDED") {
                    dispatch(setGamblingDataError("You have recently set the Self-Exclusion Limit. Try after 12AM"));
                } else if (res?.data?.result?.message === "USERLIMITS_WEEKLY_DEPOSIT_LIMIT_LESSER_THAN_DAILY_LIMIT") {
                    dispatch(setGamblingDataError("Please make sure your weekly  limit is more than daily limit."))
                } else if (res?.data?.result?.message === "USERLIMITS_MONTHLY_DEPOSIT_LIMIT_LESSER_THAN_DAILY_LIMIT") {
                    dispatch(setGamblingDataError("Please make sure your monthly  limit is more than daily limit."))
                } else if (res?.data?.result?.message === "USERLIMITS_MONTHLY_DEPOSIT_LIMIT_LESSER_THAN_WEEKLY_LIMIT") {
                    dispatch(setGamblingDataError("Please make sure your monthly  limit is more than weekly limit."))
                } else if (res?.data?.result?.message === "TIME_LIMIT_UPDATES_PER_DAY_EXCEEDED") {
                    dispatch(setGamblingDataError("You have recently set the Time Limit. Try after 12AM"))
                } else {
                    dispatch(setGamblingDataError(res?.data?.result?.message))
                }
            }
        })
}